import script from "./ListaDeUsuarios.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListaDeUsuarios.vue?vue&type=script&lang=ts&setup=true"

import "./ListaDeUsuarios.vue?vue&type=style&index=0&id=5536ff83&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5536ff83"]])

export default __exports__